import Link from 'next/link'
import ReactMarkdown from 'react-markdown'
import dateFormat from 'dateformat'
import { Box, Link as ThemeLink } from 'theme-ui'

function truncateSummary(content) {
    const limit = 300
    if (content.length < limit) {
        return content
    }
    return `${content.slice(0, limit).trimEnd()}...`
}

function reformatDate(fullDate) {
    const parsed = Date.parse(fullDate)
    return dateFormat(parsed, 'mmm dS yyyy')
}

const List = ({ allBlogs }) => {
    const postsSortedByDate = allBlogs.sort(function (a, b) {
        const dateA = new Date(a.frontmatter.date)
        const dateB = new Date(b.frontmatter.date)
        return dateB - dateA
    })

    return (
        <Box
            as="ul"
            sx={{ listStyle: 'none', maxWidth: 840, mx: 'auto', py: 4, px: 5 }}
        >
            {postsSortedByDate &&
                postsSortedByDate.map((post) => (
                    <Box
                        as="li"
                        key={post.slug}
                        sx={{ pb: 8, display: 'block' }}
                    >
                        <ThemeLink
                            as={Link}
                            sx={{
                                textDecoration: 'none',
                                color: 'text',
                                ':hover h2': { opacity: 0.8 },
                            }}
                            href={{ pathname: `/blog/${post.slug}` }}
                        >
                            <Box>
                                <Box
                                    as="time"
                                    dateTime={reformatDate(
                                        post.frontmatter.date
                                    )}
                                    sx={{
                                        textAlign: 'center',
                                        fontSize: 1,
                                        textTransform: 'uppercase',
                                        fontFamily: 'body',
                                        letterSpacing: 1.2,
                                        mb: 3,
                                        display: 'block',
                                    }}
                                >
                                    {reformatDate(post.frontmatter.date)}
                                </Box>
                                <Box
                                    as="h2"
                                    sx={{
                                        textAlign: 'center',
                                        fontFamily: 'heading',
                                        fontSize: [6, 6, 7, 7],
                                        lineHeight: 1.2,
                                        textAlign: 'center',
                                        mb: 3,
                                        textDecoration: 'underline',
                                        textUnderlineOffset: [
                                            '6px',
                                            '6px',
                                            '8px',
                                            '8px',
                                        ],
                                        textDecorationThickness: '1.5px',
                                    }}
                                >
                                    {post.frontmatter.title}
                                </Box>
                                <Box
                                    sx={{
                                        textAlign: 'center',
                                        mx: 'auto',
                                        fontFamily: 'body',
                                        fontWeight: 400,
                                        fontSize: [3, 3, 3, 3],
                                    }}
                                >
                                    <ReactMarkdown
                                        disallowedElements={['a', 'h1', 'h2']}
                                    >
                                        {truncateSummary(post.markdownBody)}
                                    </ReactMarkdown>
                                </Box>
                            </Box>
                        </ThemeLink>
                    </Box>
                ))}
        </Box>
    )
}

export default List
